module.exports = __webpack_public_path__ + "static/aisle-mgmt-logo@2x-1329b64866b1be8680faeac23ca69904.png";